// extracted by mini-css-extract-plugin
export var boxItems = "_6l-1";
export var boxItemsLg = "_6l-2";
export var button = "_6l-7";
export var buttonHoverless = "_6l-9";
export var buttonLg = "_6l-8";
export var filterGroupBox = "_6l-0";
export var icon = "_6l-3";
export var iconSecondary = "_6l-6";
export var iconWrapper = "_6l-4";
export var iconWrapperLg = "_6l-5";
export var truncatedLabel = "_6l-a";